import { render, staticRenderFns } from "./VcardHeader.vue?vue&type=template&id=61a24110&scoped=true&"
import script from "./VcardHeader.vue?vue&type=script&lang=js&"
export * from "./VcardHeader.vue?vue&type=script&lang=js&"
import style0 from "./VcardHeader.vue?vue&type=style&index=0&id=61a24110&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a24110",
  null
  
)

export default component.exports